import React from 'react';

const WhatsAppButton = () => {
  const whatsappNumber = "9011555048";
  const message = "Hi, I'm interested in solar installation. Please share more details.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      <style>{`
        @keyframes wa-pulse {
          0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7), 0 4px 15px rgba(37, 211, 102, 0.4); }
          70% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0), 0 4px 20px rgba(37, 211, 102, 0.6); }
          100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0), 0 4px 15px rgba(37, 211, 102, 0.4); }
        }
        @keyframes wa-bounce {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-6px) scale(1.05); }
        }
        .wa-btn {
          animation: wa-pulse 2s infinite, wa-bounce 3s ease-in-out infinite;
        }
        .wa-btn:hover {
          animation: none;
          transform: scale(1.15);
          box-shadow: 0 8px 30px rgba(37, 211, 102, 0.8);
        }
      `}</style>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="wa-btn fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 rounded-full transition-all duration-300"
        style={{ background: 'linear-gradient(135deg, #25D366, #128C7E)' }}
        aria-label="Chat on WhatsApp"
        title="Chat with us on WhatsApp"
      >
        {/* Official WhatsApp SVG Logo */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 175.216 175.552"
          className="w-9 h-9"
          fill="white"
        >
          <path d="M87.184 0C39.11 0 0 39.08 0 87.192c0 15.254 3.97 29.964 10.925 42.67L0 175.552l47.396-10.612c12.327 6.44 26.339 10.11 41.16 10.11 48.075 0 87.66-39.08 87.66-87.192C176.216 39.782 135.259 0 87.184 0zm0 159.69c-13.217 0-25.583-3.58-36.14-9.85l-25.942 5.81 5.98-25.198c-6.79-10.917-10.727-23.78-10.727-37.26 0-39.96 32.528-72.458 72.83-72.458 40.3 0 72.83 32.498 72.83 72.458 0 39.96-32.53 72.498-72.83 72.498zm40.285-54.376c-2.205-1.1-13.055-6.44-15.082-7.18-2.026-.74-3.5-1.1-4.97 1.103-1.471 2.203-5.69 7.18-6.975 8.647-1.285 1.47-2.57 1.652-4.774.55-2.205-1.1-9.31-3.434-17.74-10.95-6.557-5.847-10.984-13.072-12.27-15.275-1.285-2.203-.137-3.393 0.965-4.49.99-.988 2.205-2.573 3.307-3.86 1.103-1.286 1.47-2.203 2.205-3.673.736-1.47.368-2.756-.183-3.86-.55-1.103-4.97-11.96-6.81-16.38-1.793-4.306-3.617-3.72-4.97-3.79-1.285-.066-2.757-.08-4.23-.08-1.47 0-3.858.55-5.88 2.754-2.022 2.203-7.71 7.54-7.71 18.395s7.893 21.334 8.995 22.804c1.103 1.47 15.53 23.722 37.63 33.267 5.26 2.27 9.367 3.626 12.564 4.645 5.28 1.683 10.085 1.445 13.888.877 4.237-.635 13.055-5.338 14.895-10.493 1.84-5.155 1.84-9.573 1.288-10.493-.55-.92-2.023-1.47-4.23-2.57z"/>
        </svg>
      </a>
    </>
  );
};

export default WhatsAppButton;
